// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__bOA2r","navContainer":"Navbar_navContainer__j-89p","navTitleContainer":"Navbar_navTitleContainer__oAhtA","navTitle":"Navbar_navTitle__QdgXL"};